import { render } from "./TextoVisualizacao.vue?vue&type=template&id=091a1264&scoped=true&ts=true"
import script from "./TextoVisualizacao.vue?vue&type=script&lang=ts"
export * from "./TextoVisualizacao.vue?vue&type=script&lang=ts"

import "./TextoVisualizacao.vue?vue&type=style&index=0&id=091a1264&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-091a1264"]])

export default __exports__